import { getDetails, postDetails, postWithoutCredentials } from "../../services/http/http.service";
import StorageService from "../../services/storage/storage.service";
import APIList from "../../utils/constants/APIList";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import { hideLoader } from "../Loader/loader.slice";
import { hideToast, showToast } from "../Toast/toast.slice";
import { setPageNumber } from "../pageData/pageData.slice";
import store from "../store";
import {
  setAccess,
  setCanAddUsers,
  setEmailVerification,
  setFirstTimeUser,
  setKeys,
  setOTPRequested,
  setPrimaryUser,
  setProdOrders,
  setLiveOrders,
  setUATOrders,
  setUser,
  setUserCartItems,
  setUserProdCartItems,
  setWishListedItems,
} from "./authentication.slice";

export const checkEmail = (payload: any) => {
  return async (dispatch: any) => {
    try {
      payload.email = payload.email.toLowerCase();
      const response = await postWithoutCredentials(APIList.USER_EMAIL_CHECK, payload);
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setUser({ user_id: "", email: payload.email, token: "" }));
        dispatch(setEmailVerification(true));
        dispatch(setOTPRequested(true));
        return { requestedOTP: true };
      }

      return { requestedOTP: false };
    } catch (error) {
      return { requestedOTP: false };
    }
  };
};

export const registerNewUser = (payload: any) => {
  return async (dispatch: any) => {
    try {
      payload.email = payload.email.toLowerCase();
      const response = await postWithoutCredentials(APIList.USER_REGISTER, payload);
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setEmailVerification(false));
        dispatch(setOTPRequested(false));

        let temp = {
          techPerson: false,
          rbiRegistrar: false,
          sebiRegistrar: false,
        };

        if (Array.isArray(response.data.data.user_category) && response.data.data.user_category.length !== 0) {
          response.data.data.user_category.forEach((category: any) => {
            if (category.name.replaceAll(" ", "").toLowerCase() === "registeredwithrbi") {
              temp = { ...temp, rbiRegistrar: true };
            } else if (category.name.replaceAll(" ", "").toLowerCase() === "technicalserviceprovider") {
              temp = { ...temp, techPerson: true };
            } else if (category.name.replaceAll(" ", "").toLowerCase() === "registeredwithsebi") {
              temp = { ...temp, sebiRegistrar: true };
            }
          });
        }

        StorageService.setToStorage({
          user: {
            user_id: `${response.data.data.user_id.id}`,
            token: response.data.data.token,
            refreshToken: response.data.data.refreshToken,
          },
        });
        const userData = {
          user_id: `${response.data.data.user_id.id}`,
          email: response.data.data.email,
          token: response.data.data.token,
          organization_name: response.data.data.organization_name,
          phone_number: response.data.data.phone_number || "",
          rbi_code: response.data.data.ria_code || "",
          registered_with_rbi: temp.rbiRegistrar,
          registered_with_sebi: temp.sebiRegistrar,
          sebi_code: response.data.data.arn_code || "",
          technical_service_provider: temp.techPerson,
          user_category: response?.data?.data?.user_category,
          pan: response.data.pan || "",
        };

        dispatch(setUser(userData));
        dispatch(setUserCartItems(response.data.data.cart));
        dispatch(setUserProdCartItems(response.data.data.prodCart));
        dispatch(setUATOrders(response.data.data.uatOrder));
        dispatch(setProdOrders(response.data.data.ProdOrder));
        dispatch(setLiveOrders(response.data.data.liveOrder));
        dispatch(setWishListedItems(response.data.data.wishlist));
        dispatch(setAccess({ hasUATAccess: response.data.data.hasUatAccess, hasProdAccess: response.data.data.hasProdAccess }));
        dispatch(setCanAddUsers(response.data.data.canAddUsers));
        dispatch(setPrimaryUser(response.data.data.isPrimaryUser));
        return { isLoggedIn: true };
      }

      return { isLoggedIn: false };
    } catch (error) {
      return { isLoggedIn: null };
    }
  };
};

export const verifyotp = (payload: any) => {
  return async (dispatch: any) => {
    try {
      payload.email = payload.email.toLowerCase();
      console.log(payload);
      const response = await postWithoutCredentials(APIList.USER_VERIFY_OTP, payload);
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setEmailVerification(true));
        dispatch(setOTPRequested(false));
        const primaryData = response.data.primaryUserData as { organization_name: string; user_category: Array<number> };
        if (response.data.isFirstTimeUser) {
          dispatch(setFirstTimeUser(true));
          return { firstTimeUser: true, isPrimaryUser: response.data.isPrimaryUser, primaryUserData: primaryData };
        }

        let temp = {
          techPerson: false,
          rbiRegistrar: false,
          sebiRegistrar: false,
        };

        if (Array.isArray(response.data.data.user_category) && response.data.data.user_category.length !== 0) {
          response.data.data.user_category.forEach((category: any) => {
            if (category.name.replaceAll(" ", "").toLowerCase() === "registeredwithrbi") {
              temp = { ...temp, rbiRegistrar: true };
            } else if (category.name.replaceAll(" ", "").toLowerCase() === "technicalserviceprovider") {
              temp = { ...temp, techPerson: true };
            } else if (category.name.replaceAll(" ", "").toLowerCase() === "registeredwithsebi") {
              temp = { ...temp, sebiRegistrar: true };
            }
          });
        }

        StorageService.setToStorage({
          user: {
            user_id: `${response.data.data.user_id.id}`,
            token: response.data.data.token,
            refreshToken: response.data.data.refreshToken,
          },
        });
        const userData = {
          user_id: `${response.data.data.user_id.id}`,
          email:  response.data.data.email,
          token: response.data.data.token,
          organization_name: response.data.data.organization_name,
          phone_number: response.data.data.phone_number,
          rbi_code: response.data.data.ria_code || "",
          registered_with_rbi: temp.rbiRegistrar,
          registered_with_sebi: temp.sebiRegistrar,
          sebi_code: response.data.data.arn_code || "",
          technical_service_provider: temp.techPerson,
          user_category: response?.data?.data?.user_category,
          pan: response.data.pan || "",
        };

        dispatch(setUser(userData));
        dispatch(setUserCartItems(response.data.data.cart));
        dispatch(setUserProdCartItems(response.data.data.prodCart));
        dispatch(setUATOrders(response.data.data.uatOrder));
        dispatch(setProdOrders(response.data.data.ProdOrder));
        dispatch(setLiveOrders(response.data.data.liveOrder));
        dispatch(setWishListedItems(response.data.data.wishlist));
        dispatch(setAccess({ hasUATAccess: response.data.data.hasUatAccess, hasProdAccess: response.data.data.hasProdAccess }));
        dispatch(setPrimaryUser(response.data.data.isPrimaryUser));
        dispatch(setCanAddUsers(response.data.data.canAddUsers));
        const keys = {
          uatKey: response.data.data?.uatkey === null ? "" : response.data.data?.uatkey || "",
          prodKey: response.data.data?.prodkey === null ? "" : response.data.data?.prodkey || "",
        };

        dispatch(setKeys(keys));

        return { firstTimeUser: false, isPrimaryUser: false, primaryUserData: primaryData };
      }

      return { firstTimeUser: null };
    } catch (error) {
      return { firstTimeUser: null };
    }
  };
};

/** Get user details */
export const getUserDetails = () => {
  return async (dispatch: any) => {
    const response = await getDetails(APIList.USER_GET_INFO, getUserDetails);
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      let temp = {
        techPerson: false,
        rbiRegistrar: false,
        sebiRegistrar: false,
      };

      if (Array.isArray(response.data.user_category) && response.data.user_category.length !== 0) {
        response.data.user_category.forEach((category: any) => {
          if (category.name.replaceAll(" ", "").toLowerCase() === "registeredwithrbi") {
            temp = { ...temp, rbiRegistrar: true };
          } else if (category.name.replaceAll(" ", "").toLowerCase() === "technicalserviceprovider") {
            temp = { ...temp, techPerson: true };
          } else if (category.name.replaceAll(" ", "").toLowerCase() === "registeredwithsebi") {
            temp = { ...temp, sebiRegistrar: true };
          }
        });
      }

      const userData = {
        user_id: `${response.data.id}`,
        email: response.data.email,
        organization_name: response.data.organization_name,
        phone_number: response.data.phone_number,
        rbi_code: response.data.ria_code || "",
        registered_with_rbi: temp.rbiRegistrar,
        registered_with_sebi: temp.sebiRegistrar,
        sebi_code: response.data.arn_code || "",
        technical_service_provider: temp.techPerson,
        user_category: response?.data?.user_category,
        pan: response.data.pan || "",
      };

      dispatch(setUser(userData));
      dispatch(setUserCartItems(response.data.cart));
      dispatch(setUserProdCartItems(response.data.prodCart));
      dispatch(setUATOrders(response.data.uatOrder));
      dispatch(setProdOrders(response.data.ProdOrder));
      dispatch(setLiveOrders(response.data.liveOrder));
      dispatch(setWishListedItems(response.data.wishlist));
      dispatch(setAccess({ hasUATAccess: response.data.hasUatAccess, hasProdAccess: response.data.hasProdAccess }));
      dispatch(setPrimaryUser(response.data.isPrimaryUser));
      dispatch(setCanAddUsers(response.data.canAddUsers));

      const keys = {
        uatKey: response.data?.uatkey === null ? "" : response.data?.uatkey || "",
        prodKey: response.data?.prodkey === null ? "" : response.data?.prodkey || "",
      };

      dispatch(setKeys(keys));
    } else {
      localStorage.clear();
    }
  };
};

/** Logout user */
export const logoutUser = () => {
  return async (dispatch: any) => {
    try {
      const userData = {
        user_id: "",
        email: "",
        organization_name: "",
        phone_number: "",
        rbi_code: "",
        registered_with_rbi: "",
        registered_with_sebi: "",
        sebi_code: "",
        technical_service_provider: "",
        user_category: [],
        pan: "",
      };
      dispatch(setUser(userData));
      dispatch(setEmailVerification(false));
      dispatch(setUserCartItems([]));
      dispatch(setUserProdCartItems([]));
      dispatch(setWishListedItems([]));
      dispatch(setUATOrders([]));
      dispatch(setProdOrders([]));
      dispatch(setLiveOrders([]));
      dispatch(setPageNumber(0));
      dispatch(setCanAddUsers(false));
      dispatch(setKeys({ uatKey: "", prodKey: "" }));
      let response = await getDetails(APIList.USER_LOGOUT);
      localStorage.clear();
      sessionStorage.clear();

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        store.dispatch(showToast("Logged out successfully !!!"));
        setTimeout(() => store.dispatch(hideToast()), 2000);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };
};

/** Refresh token */
export const refreshToken = async (url: string, callbackFun: Function, method?: "GET" | "POST", payload?: any) => {
  try {
    const { user } = StorageService.getFromStorage(["user"]);
    const userData = {
      user_id: "",
      email: "",
      organization_name: "",
      phone_number: "",
      rbi_code: "",
      registered_with_rbi: "",
      registered_with_sebi: "",
      sebi_code: "",
      technical_service_provider: "",
      user_category: [],
      pan: "",
    };

    if (typeof user === "undefined") {
      localStorage.clear();
      sessionStorage.clear();
      store.dispatch(setUser(userData));
      store.dispatch(setEmailVerification(false));
      store.dispatch(setUserCartItems([]));
      store.dispatch(setUserProdCartItems([]));
      store.dispatch(setWishListedItems([]));
      store.dispatch(setUATOrders([]));
      store.dispatch(setProdOrders([]));
      store.dispatch(setLiveOrders([]));
      store.dispatch(setPageNumber(0));
      store.dispatch(setCanAddUsers(false));
      store.dispatch(hideLoader());
      store.dispatch(setKeys({ uatKey: "", prodKey: "" }));
      return;
    }

    /** Get new access token */

    const response = await postDetails(APIList.REFRESH_TOKEN, { refreshToken: user?.refreshToken });

    if (response.statusCode === APIResponseCodes.SUCCESS) {
      StorageService.setToStorage({
        user: {
          user_id: `${user.user_id}`,
          token: response.data.token,
          refreshToken: user?.refreshToken,
        },
      });
      store.dispatch(getUserDetails());
      callbackFun();
    } else {
      localStorage.clear();
      sessionStorage.clear();
      store.dispatch(setUser(userData));
      store.dispatch(hideLoader());
    }
  } catch (error) {
    localStorage.clear();
    sessionStorage.clear();
    store.dispatch(hideLoader());
  }
};
